<template>
    <div class="prompt-box" v-show="promptShow">
        <p v-html="message"></p>
    </div>
</template>

<script>
    export default{
        name:'prompt',
        data(){
            return {
                promptShow:false
            }
        },
        props:{
            message:String,
            callBack:Function
        },
        mounted(){
            var _this = this;
            setTimeout(function(){
                _this.promptShow = false;
                if(_this.callBack!=null){
                    _this.callBack()

                }
            },1500)
        }
    }
</script>

<style scoped>
    .prompt-box{
        font-size: .28rem;
        position: fixed;
        top:0;
        left: 0;
        right:0;
        bottom: 0;
        z-index: 99999;
        background: rgba(255,255,255,.1);
    }
    .prompt-box p{
        padding: .38rem .44rem;
        position: absolute;
        top:30%;
        left: 50%;
        -webkit-transform: translateX(-50%);
        background: rgba(0,0,0,.7);
        color: #ffffff;
        border-radius: .2rem;
        max-width: 3rem;
        text-align: center;
    }
</style>


// WEBPACK FOOTER //
// src/components/prompt/prompt.vue